import { __decorate } from "tslib";
import colors from '@/styles/color.scss';
import lang from '@blade-sxp/portrait-management/lang/index';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import CombinedPicture from '@blade-sxp/portrait-management/components/combined-picture.vue';
import PortraitCardItem from '@blade-sxp/portrait-management/pages/components/portrait-card-item.vue';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { PageQueryTypeEnum } from '@blade-sxp/portrait-management/interfaces/common';
import { deletePortraitRelation, queryPortraitDetail } from '@blade-sxp/portrait-management/api/portrait';
import AuthNewitem from '@blade/common/components/auth/auth-newItem.vue';
import { permissionlevel } from '@blade/common/constants/role-mode';
import { SYSTEMCODE } from '@blade/common/constants/code';
const Webapi = {
    deletePortraitRelation,
    queryPortraitDetail,
};
let default_1 = class default_1 extends Vue {
    data;
    selection;
    loading;
    pagination;
    refresh;
    allowSelect;
    // 权限级别
    permissionlevel = permissionlevel;
    systemCode = SYSTEMCODE;
    /** 图标默认尺寸 */
    iconSize = 12;
    /** 表头背景色 */
    cellBackground = colors.colorBoxBg;
    /** 默认的页面尺寸列表 */
    defaultPageSize = [16, 32, 80, 160];
    /** 提交中 */
    submiting = false;
    /** 选中的元素 */
    checkItems = {};
    portraitStatusNormal = 'NORMAL'; // 未失效
    portraitStatusInvalidating = 'INVALIDATING'; // 失效
    checkItemChange() {
        this.handleSelectionChange();
    }
    /** 外部使用此方法修改选项 */
    selectionChange(selection) {
        let checkItems = {};
        if (!selection)
            selection = this.selection;
        for (const portrait of selection) {
            checkItems[portrait.portraitId] = portrait;
        }
        this.checkItems = checkItems;
    }
    getCheck(val) {
        return val.portraitStatus === this.portraitStatusInvalidating;
    }
    /** 失效状态颜色更改 */
    getInvalid(row) {
        return row.portraitStatus === this.portraitStatusInvalidating ? `pointer-events: none;color:${colors.searchTextBlack}` : '';
    }
    getInvalidDisabled(row) {
        return !(row.portraitStatus !== this.portraitStatusInvalidating);
    }
    /** 清空选中项 */
    clearSelection() {
        this.checkItems = {};
    }
    /** 去编辑页面 */
    handleEdit(item) {
        const query = this.$route.query;
        this.$router.push({ name: 'portraitCreate', query: { ...query, type: PageQueryTypeEnum.EDIT, id: item.portraitId.toString() } });
    }
    /** 更改页面尺寸 */
    handleSizeChange(val) {
        this.pagination.size = val;
        this.$emit('update:pagination', this.pagination);
        this.clearSelection();
    }
    /** 修改当前页 */
    handleCurrentChange(val) {
        this.pagination.page = val;
        this.$emit('update:pagination', this.pagination);
        this.clearSelection();
    }
    /** 修改选中项 */
    handleSelectionChange() {
        this.$emit('update:selection', Object.values(this.checkItems).filter((a) => a));
    }
    /** 点击卡片前往详情 */
    handleCard(item) {
        const query = this.$route.query;
        this.$router.push({ name: 'portraitCreate', query: { ...query, type: PageQueryTypeEnum.DETAIL, id: item.portraitId.toString() } });
    }
    /** 删除 */
    handleDelete(item) {
        if (this.loading)
            return;
        this.$elconfirm(`${this.$t('deletePortraitTip')}`, `${this.$t('tip')}`, {
            type: 'warning',
            cancelButtonText: `${this.$t('common.cancel')}`,
            confirmButtonText: ` ${this.$t('common.confirm')}`,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: (action) => {
                if (action === 'confirm') {
                    this.deletePortraitRelation(item);
                }
            },
        });
    }
    /** 删除接口封装 */
    async deletePortraitRelation(item) {
        try {
            this.$emit('update:loading', true);
            await Webapi.deletePortraitRelation(item); // 逻辑确认过了 失败非200
            this.$message({
                customClass: 'success-message',
                message: this.$t('deletedSuccessfully'),
                type: 'success',
                showClose: true,
            });
            this.refresh();
        }
        catch (error) {
            console.log('deletePortraitRelation error', error);
            this.$emit('update:loading', false);
        }
    }
};
__decorate([
    Prop()
], default_1.prototype, "data", void 0);
__decorate([
    Prop()
], default_1.prototype, "selection", void 0);
__decorate([
    Prop()
], default_1.prototype, "loading", void 0);
__decorate([
    Prop()
], default_1.prototype, "pagination", void 0);
__decorate([
    Prop()
], default_1.prototype, "refresh", void 0);
__decorate([
    Prop()
], default_1.prototype, "allowSelect", void 0);
__decorate([
    Watch('checkItems', { deep: true })
], default_1.prototype, "checkItemChange", null);
default_1 = __decorate([
    Component({
        i18n: { messages: lang },
        components: {
            BlurPicture,
            CombinedPicture,
            PortraitCardItem,
            AuthNewitem,
        },
    })
], default_1);
export default default_1;
